import React from 'react';
import {Link} from 'react-router-dom';
import styleExplore from "../style/explore.module.css";
import style from '../style/notification.module.css';
import {IoIosArrowBack} from "react-icons/io";
import data from '../data/notification.json';

function Notification(){
    return(
        <div className={style.notificationContainer}>
            <div className={`${styleExplore.head} px-2 pt-2 pb-3`}>
                <Link to="/home" className={styleExplore.btnBack}>
                    <IoIosArrowBack/>
                </Link>
                <h3 className='mx-auto'>Activity</h3>
            </div>
            <div className="mt-2">
                {
                    data.map((item)=>{
                        const {picture, description, lastDay} = item;
                        return(
                            <div className={`${style.notification} d-flex align-items-center mb-2`}>
                                <img src={picture} alt="person" className='mx-2'/>
                                <h4>{description}</h4>
                                <p>{lastDay}</p>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
export default Notification;